import { TabBar } from '@practium/ui';
import type { ParametersView } from '../../../types/parameters.types';

const VIEW_TABS: { key: ParametersView; label: string }[] = [
	{ key: 'states', label: 'Regiões' },
	{ key: 'plan', label: 'Plano de cálculo' },
];

interface ViewSwitchProps {
	view: ParametersView;
	onChange: (view: ParametersView) => void;
}

export const ViewSwitch = ({ view, onChange }: ViewSwitchProps) => (
	<TabBar tabs={VIEW_TABS} activeTab={view} onTabChange={onChange} />
);
